/**
 * Filter card header for RmaListFilterControl: bold label and chevron.
 */
import React from "react";
import FontBody2 from "../../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_VARIANT } from "../../../../../../../../../components/fonts/font-props";
import IconChevronDown from "../../../../../../../../../components/icons/icon-chevron-down/icon-chevron-down";

interface IProps {
    label: string;
}

const RmaListFilterControlHeader: React.FC<IProps> = ({ label }) => (
    <div className="rma-list-filter-control__header">
        <span className="rma-list-filter-control__label">
            <FontBody2 variant={FONT_VARIANT.BOLD}>{label}</FontBody2>
        </span>
        <span className="rma-list-filter-control__chevron">
            <IconChevronDown color="var(--color-neutral-3)" />
        </span>
    </div>
);

export default RmaListFilterControlHeader;
